import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import Header from './common/header';
import JoinForm from './common/join-form';
import SiteMap from './common/site-map';
import Footer from './common/footer';
import Hero from './homepage-elements/hero';
import Welcome from './homepage-elements/welcome';
import Purpose from './homepage-elements/purpose';
import Contributors from './homepage-elements/contributors';
import Features from './homepage-elements/features';
import Investors from './homepage-elements/investors';
import OurStory from './homepage-elements/our-story';

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
`;

export default function Homepage(props) {
  const common = commonProps();
  const state = {
    ...props,
    ...common,
    light: true,
  };

  return (
    <ThemeProvider theme={state}>
      <Container>
        <Header />
        <Hero />
        <Welcome />
        <Purpose />
        <Contributors />
        <Features />
        <Investors />
        <OurStory />
        {!common.isUserSignedIn && <JoinForm />}
        <SiteMap />
        <Footer />
      </Container>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
Homepage.propTypes = {
  logo: PropTypes.string.isRequired,
  hero: PropTypes.string.isRequired,
  heroPortrait: PropTypes.string.isRequired,
  ourStory: PropTypes.string.isRequired,
  media: PropTypes.arrayOf(PropTypes.string).isRequired,
  purpose: PropTypes.string.isRequired,
  contributors: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    company: PropTypes.string,
  })).isRequired,
  investors: PropTypes.arrayOf(PropTypes.shape({
    logo: PropTypes.string.isRequired,
    headshot: PropTypes.string.isRequired,
  })).isRequired,
};
/* eslint-enable react/no-unused-prop-types */
